<template>
    <span :title="$t(lastresult.getResultValueInfo().label)" :class="lastresult.getResultValueInfo().color">
        <span class="text-bold">
            
            <!--PROGRESS-->
            <span v-if="[true, 'R'].includes(isRunning) && progress!=null" :title="$t('Running')" class="fg-dark"> 
                <div class="text-center mb-1">{{ progress }}%</div>
                <div data-role="progress" data-cls-buffer="bg-dark" data-cls-back="bg-dark" data-type="load" :data-value="progress" :data-buffer="100" data-small="true"></div>
            </span>

            <!--SIMBOLO-->
            <span v-if="lastresult == $ResultValue.OK" class="align-items-center dot"> ● </span>
            <span v-if="lastresult == $ResultValue.SomeWarnings" class="align-items-center dot"> ● </span>
            <span v-if="lastresult == $ResultValue.Error" class="align-items-center dot"> ● </span>
            <span v-if="lastresult == $ResultValue.Running" class="align-items-center ani-flash dot"> ● </span>
            <span v-if="lastresult == $ResultValue.Aborted" class="align-items-center dot "> ● </span>
            <span v-if="lastresult == $ResultValue.NeverExecuted" class="align-items-center dot"> ● </span>
            <span v-if="lastresult == $ResultValue.TerminatedAbnormally" class="h5">!</span>
            <span v-if="lastresult == $ResultValue.FeatureNotEnabled" class="h5">
                <svg fill="#ce352c" height="17px" width="17px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 27.963 27.963" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g id="c129_exclamation"> <path d="M13.983,0C6.261,0,0.001,6.259,0.001,13.979c0,7.724,6.26,13.984,13.982,13.984s13.98-6.261,13.98-13.984 C27.963,6.259,21.705,0,13.983,0z M13.983,26.531c-6.933,0-12.55-5.62-12.55-12.553c0-6.93,5.617-12.548,12.55-12.548 c6.931,0,12.549,5.618,12.549,12.548C26.531,20.911,20.913,26.531,13.983,26.531z"></path> <polygon points="15.579,17.158 16.191,4.579 11.804,4.579 12.414,17.158 "></polygon> <path d="M13.998,18.546c-1.471,0-2.5,1.029-2.5,2.526c0,1.443,0.999,2.528,2.444,2.528h0.056c1.499,0,2.469-1.085,2.469-2.528 C16.441,19.575,15.468,18.546,13.998,18.546z"></path> </g> <g> </g> </g> </g></svg>
            </span>

        </span>

        <!--LABEL-->
        <span v-if="withLabel" class="ml-1">{{ $t(lastresult.getResultValueInfo().label) }}</span>
    </span>
</template>
<script>
export default {
    name: "LastResult",
    props: {
        lastresult: {
            type: Number,
            required: true
        },
        progress: {
            type: Number,
            required: false
        },
        isRunning: {
            type: Boolean,  
            required: false
        },
        withLabel:{
            type: Boolean,  
            required: false,
            default: false
        }
    }

}
</script>